var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_1109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_92_1109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_92_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6159 0C39.1151 0 41.1309 2.0845 41.25 4.5375V44L36.4915 39.8328L33.8785 37.3798L31.0273 34.8168L32.2183 38.8593H7.26498C4.77285 38.8593 2.75 36.9068 2.75 34.32V4.54667C2.75 2.09367 4.77641 0.0055 7.27387 0.0055H36.6034L36.6159 0ZM25.7409 10.4188H25.6875L25.3284 10.7855C29.0134 11.8855 30.7962 13.6033 30.7962 13.6033C28.4214 12.3787 26.2812 11.7663 24.1411 11.5188C22.5946 11.2713 21.0481 11.4015 19.7416 11.5188H19.3861C18.5506 11.5188 16.7731 11.8855 14.3912 12.8663C13.561 13.2385 13.0847 13.4823 13.0847 13.4823C13.0847 13.4823 14.8658 11.6453 18.7906 10.6645L18.5506 10.417C18.5506 10.417 15.5786 10.2997 12.3701 12.7453C12.3701 12.7453 9.16166 18.5093 9.16166 25.6153C9.16166 25.6153 10.9392 28.8053 15.815 28.9263C15.815 28.9263 16.526 27.9492 17.246 27.0893C14.5085 26.2313 13.442 24.5153 13.442 24.5153C13.442 24.5153 13.6802 24.6363 14.0375 24.882H14.1441C14.1975 24.882 14.2223 24.9095 14.2507 24.937V24.948C14.2792 24.9773 14.3041 25.003 14.3574 25.003C14.944 25.2523 15.5306 25.498 16.0105 25.7363C16.8389 26.1067 17.9036 26.4752 19.2102 26.719C20.8632 26.9665 22.7581 27.0857 24.9161 26.719C25.9826 26.4715 27.0492 26.2295 28.1157 25.7382C28.8089 25.3715 29.6621 25.0048 30.5989 24.387C30.5989 24.387 29.5324 26.103 26.6794 26.961C27.266 27.8153 28.0926 28.7943 28.0926 28.7943C32.9701 28.6843 34.865 25.4943 34.9717 25.63C34.9717 18.535 31.7455 12.76 31.7455 12.76C28.8391 10.5343 26.1195 10.45 25.6395 10.45L25.7391 10.4133L25.7409 10.4188ZM26.0395 18.5093C27.2891 18.5093 28.297 19.6093 28.297 20.9568C28.297 22.3135 27.2838 23.4135 26.0395 23.4135C24.7952 23.4135 23.782 22.3135 23.782 20.9678C23.7855 19.6112 24.8005 18.5148 26.0395 18.5148V18.5093ZM17.9641 18.5093C19.2084 18.5093 20.2145 19.6093 20.2145 20.9568C20.2145 22.3135 19.2012 23.4135 17.9569 23.4135C16.7127 23.4135 15.6994 22.3135 15.6994 20.9678C15.6994 19.6112 16.7127 18.5148 17.9569 18.5148L17.9641 18.5093Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityDiscord);
export default __webpack_public_path__ + "static/media/community_discord.4771cac2305154c59c715a33385da133.svg";
export { ForwardRef as ReactComponent };